import { render } from "./RejectApproval.vue?vue&type=template&id=5bf2d7ac&scoped=true"
import script from "./RejectApproval.vue?vue&type=script&lang=js"
export * from "./RejectApproval.vue?vue&type=script&lang=js"

import "./RejectApproval.vue?vue&type=style&index=0&id=5bf2d7ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf2d7ac"]])

export default __exports__